
import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, ValidatorFn } from '@angular/forms';
import { DateService } from 'src/app/services/date/date.service';

/**
 * Generated class for the DayCalendarComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'date-selector',
  templateUrl: 'date-selector.component.html',
  styleUrls: ['./date-selector.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: DateSelectorComponent
    },
    {
        provide: NG_VALIDATORS, 
        useExisting: forwardRef(() => DateSelectorComponent),
        multi: true,
    },
]
})
export class DateSelectorComponent implements OnInit {
  local:string = "fr-fr";
  month:string;
  @Input()
  minDate:string;
  @Input()
  maxDate:string;
  @Input()
  dayValues:string;
  @Input()
  title:string;
  day:string;  
  year:string;
  dayName: string;
  dateStrLocal:string;
  showPicker = false;
  onChange = (value) => {};
  onTouched = () => {};
  onValidationChange: any = () => {};
  // @Input()
  // value:string | any ;

  // @Input('value')
  //   set value(value:string|any){
  //     if(value){
  //       this._value = value;
  //       const date = new Date(value);
  //       this.dateStrLocal = date.toLocaleString(this.local, { weekday: 'short', month: 'short', day: 'numeric' });        
  //     }
  //   }
  @Input()
  value: string;

  _value:string;

  touched = false;
  @Input()
  disabled = false;

  @Output() valueChanged = new EventEmitter<string>();


  constructor(dateService:DateService) {

  }

  ngOnInit(){
  }
  itemClicked(){
    // console.log(this.disabled, this.showPicker);
    this.showPicker = !this.disabled;
  }

  dateChanged(value){
    // console.log(value);
    this.writeValue(value);
    this.onChange(value);
    this.onValidationChange();
    this.showPicker = false;
    this.valueChanged.emit(value);
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }
  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  writeValue(value: string| any) {
    // console.log(value);
    if(value){
      const date = new Date(value);
      this.dateStrLocal = date.toLocaleString(this.local, { weekday: 'short', year: '2-digit', month: 'short', day: 'numeric' });
      this.value = value;
      this._value = value
    }
  }

  registerOnTouched(onTouched: any) {
      this.onTouched = onTouched;
  }

  markAsTouched() {
      if (!this.touched) {
        this.onTouched();
        this.touched = true;
      }
  }

  validate(control: AbstractControl): ValidationErrors {
      return null //this._value?null:{invalid:true};
  }

  registerOnValidatorChange?(fn: () => void): void {
      this.onValidationChange = fn;
  }

  inputValidator(): ValidatorFn  {
      return (control:AbstractControl) : ValidationErrors | null => {
          if(!this._value){
              return {label:{value:false}}
          }
          else {
              return null
          }
      };
  }
}
